import { render, staticRenderFns } from "./CompEdit.vue?vue&type=template&id=6e81969a"
import script from "./CompEdit.vue?vue&type=script&lang=js"
export * from "./CompEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports